import React, { useEffect, useState } from "react";
import { Play, ArrowUpRight } from "lucide-react";
import Reveal from "../components/Reveal";
import BlurImage from "../components/BlurImage";
import api from "../lib/api";

const SPAN = {
    large: "md:col-span-2 md:row-span-2 aspect-square md:aspect-auto",
    tall: "md:row-span-2 aspect-[3/4] md:aspect-auto",
    wide: "md:col-span-2 aspect-[16/10] md:aspect-auto",
    standard: "aspect-[4/3] md:aspect-auto",
};

export default function Portfolio() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/portfolio").then((r) => setItems(r.data)).catch(() => {}); }, []);

    return (
        <div data-testid="portfolio-page">
            <section className="bg-white py-20 lg:py-24 border-b border-neutral-200">
                <div className="mx-container text-center">
                    <p className="overline mb-5">Portfolio</p>
                    <h1 className="font-display font-black uppercase tracking-tightest text-4xl sm:text-6xl lg:text-7xl leading-[0.95] max-w-4xl mx-auto break-words">
                        Work worth<br /><span className="text-brand-blue">remembering.</span>
                    </h1>
                    <p className="mt-7 max-w-xl mx-auto text-neutral-500 text-lg">Music videos, visualizers, album campaigns and creative direction for artists across genres.</p>
                </div>
            </section>

            <section className="bg-navy py-12 lg:py-16 grain">
                <div className="mx-container">
                    <div className="grid grid-cols-1 md:grid-cols-3 md:auto-rows-[240px] gap-4">
                        {items.map((p, i) => (
                            <Reveal key={p.slug} delay={(i % 3) * 0.06} className={`${SPAN[p.size] || SPAN.standard}`}>
                                {(() => {
                                    const clickable = !!p.link_url;
                                    const Wrap = clickable ? "a" : "div";
                                    const wrapProps = clickable ? { href: p.link_url, target: "_blank", rel: "noreferrer" } : {};
                                    return (
                                        <Wrap {...wrapProps} className={`group relative block h-full w-full overflow-hidden card-lift ${clickable ? "cursor-pointer" : ""}`} data-testid={`portfolio-item-${p.slug}`}>
                                            <BlurImage src={p.cover} alt={p.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
                                            {clickable && (
                                                <div className="absolute top-4 right-4 h-11 w-11 rounded-full bg-white/15 backdrop-blur grid place-items-center opacity-0 group-hover:opacity-100 transition-opacity">
                                                    <Play className="h-4 w-4 text-white" />
                                                </div>
                                            )}
                                            <div className="absolute inset-x-0 bottom-0 p-5 text-white">
                                                <p className="text-[11px] uppercase tracking-[0.2em] text-brand-yellow mb-1">{p.category}</p>
                                                <h3 className="font-display font-black uppercase tracking-tight text-xl sm:text-2xl leading-none">{p.title}</h3>
                                                <p className="mt-1 text-xs text-white/60">{p.artist} · {p.year}{clickable && <span className="ml-2 inline-flex items-center gap-1 text-brand-yellow">· View work <ArrowUpRight className="h-3 w-3" /></span>}</p>
                                            </div>
                                        </Wrap>
                                    );
                                })()}
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}
